import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  loading: false,
  sectors: [],
  isInterestModalShown: false,
  sectorInterestId: undefined,
  sectorId: undefined,
  positionIds: [],
  formData: {
    sectors: [],
  },
};

function onLoad(state) {
  return { ...state };
}

function onLoadSuccess(state, { payload }) {
  const { records } = payload;

  return {
    ...state,
    sectors: records,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onLoadFormData(state, { payload }) {
  return {
    ...state,
    loading: false,
    formData: payload,
  };
}

function onChangeInterest(state, { payload }) {
  const { attr, value } = payload;

  return {
    ...state,
    [attr]: value,
  };
}

function onToggleInterestModal(state) {
  return { ...state, isInterestModalShown: !state.isInterestModalShown };
}

function onClearInterest(state) {
  return {
    ...state,
    sectorInterestId: undefined,
    sectorId: undefined,
    positionIds: [],
  };
}

export default createReducer(initState, {
  [actions.CHANGE_INTEREST]: onChangeInterest,
  [actions.CLEAR_INTEREST]: onClearInterest,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_REQUEST]: onLoad,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.TOGGLE_INTEREST_MODAL]: onToggleInterestModal,
});
